// extracted by mini-css-extract-plugin
module.exports = {"mediaWidthMobile":"767px","mediaWidthTablet":"1023px","mediaWidthTabletLand":"1365px"};